import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../../../core/api/api.service';
import { ENDPOINTS } from '../../../../core/api/endpoints';
import { API_HOST } from '../../../../core/api/api.config';
import { PermissionService } from '../../../shared/services/permission.service';


@Injectable({
  providedIn: 'root',
})
export class AdminService {

  constructor(
    private api: ApiService,
    private permissionService: PermissionService
  ) {}

  /* ================= SAVE ROLE ================= */

  saveRole(payload: any): Observable<any> {

    return this.api.post(
      API_HOST.admin,
      ENDPOINTS.ADMIN.SAVE_ROLE,
      payload
    );

  }

  /* ================= SAVE APP ACCESS ================= */

  saveAppAccess(payload: any): Observable<any> {

    return this.api.post(
      API_HOST.admin,
      ENDPOINTS.ADMIN.SAVE_APP_ACCESS,
      payload
    );

  }

  /* ================= GET AUTH LIST ================= */

  getAuthList(roleId: string): Observable<any> {

    return this.api.get(
      API_HOST.admin,
      ENDPOINTS.ADMIN.GET_AUTH_LIST + roleId
    );

  }

  /* ================= LOAD USER PERMISSIONS ================= */

loadUserPermissions(): void {
  const role = localStorage.getItem('role') || '';
  const roleId = role.includes('_') ? role.split('_').slice(1).join('_') : role;

  if (!roleId) return;

  this.getAuthList(roleId).subscribe({
    next: (res: any) => {
      const permissions = res?.data || res || [];
      this.permissionService.setPermissions(permissions);
    },
    error: (err) => {
      console.error('Permission Load Failed', err);
    }
  });
}

  /* ================= GET AUTH LIST FOR ROLE ================= */

  getAuthListForRole(roleSeq: number): Observable<any> {

    return this.api.get(
      API_HOST.admin,
      ENDPOINTS.ADMIN.GET_AUTH_LIST_FOR_ROLE + roleSeq
    );

  }

  /* ================= GET ALL SUB MODES ================= */

  getAllSubModes(): Observable<any> {

    return this.api.get(
      API_HOST.admin,
      ENDPOINTS.ADMIN.GET_ALL_SUB_MODES
    );

  }

  /* ================= GET ALL ROLES ================= */

  getAllRoles(): Observable<any> {

    return this.api.get(
      API_HOST.admin,
      ENDPOINTS.ADMIN.GET_ALL_ROLES
    );

  }

  /* ================= GET ALL MODES ================= */

  getAllModes(): Observable<any> {

    return this.api.get(
      API_HOST.admin,
      ENDPOINTS.ADMIN.GET_ALL_MODES
    );

  }

}